module.exports = __webpack_public_path__ + "img/27.8.TSS.69a9f11e.png";